import { useEffect, useRef } from 'react';
import rescuePositionIcon from "../assets/car_icon.png";


type Props = {
  __map__?: any;
  __amapui__?: any;
  gpsInfo?: {
    lng?: any;
    lat?: any;
  };
  orderNumber?: string;
};

export default function MapMarker(props: Props) {
  const { __map__, gpsInfo, orderNumber } = props;
  const mapMarker = useRef<any>(null);

  useEffect(() => {
    // 移除原本的标记 || 如果没有 orderNumber 则清空车辆标记
    if(mapMarker.current) {
      mapMarker.current.setMap(null)
    }
    if(!orderNumber) return;

    if (gpsInfo && gpsInfo.lng && gpsInfo.lat) {
      mapMarker.current = new window.AMap.Marker({
        position: new window.AMap.LngLat(
          gpsInfo.lng,
          gpsInfo.lat
        ),
        title: "救援车",
        icon: new window.AMap.Icon({
          size: new AMap.Size(30, 52.5),
          imageSize: new AMap.Size(30, 52.5),
          image: rescuePositionIcon,
        }),
      });

      __map__.add(mapMarker.current);
    }

    if (mapMarker.current) {
      let markerRescueLngLat = mapMarker.current.getPosition();
      __map__.setCenter(markerRescueLngLat);
      __map__.setZoom(16);
    }
  }, [gpsInfo, __map__, orderNumber]);

  return null;
}
